import * as storeActions from '~/store/actions';
import { mapState } from 'vuex';
import _ from 'lodash';
import Debug from '~/utils/debug';
import { LOGIN_TYPES } from '~/utils/constants';
import Email from './email/Email.vue';
import Token from './token/Token.vue';
import Sso from './sso/Sso.vue';

const debug = Debug('login');

export default {
  components: {
    email: Email,
    token: Token,
    Sso,
  },
  data() {
    return {
      LOGIN_TYPES,
    };
  },
  computed: {
    ...mapState('router', {
      nextRoute: state => _.get(state, 'query.next', '/') || '/',
      token: state => _.get(state, 'query.token', null),
    }),
    ...mapState('auth', ['user']),
    ...mapState('publicConfig', ['config']),
    availableLoginOptions() {
      return _.get(this.config, 'login_types', ['email']);
    },
    showEmailLogin() {
      return _.includes(this.availableLoginOptions, LOGIN_TYPES.EMAIL);
    },
    showSSOLogin() {
      return _.includes(this.availableLoginOptions, LOGIN_TYPES.SSO);
    },
  },
  methods: {
    onLogin(type) {
      debug('successful login, routing to %s', this.nextRoute);
      storeActions.setLoginType(type);
      if (this.nextRoute && this.nextRoute.match(/^https?:\/\//)) {
        document.location = this.nextRoute;
      } else {
        this.$router.push(this.nextRoute);
      }
    },
  },
  mounted() {
    if (this.user) {
      this.$router.push('/');
    }
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/login/Login.js